class PaymentAmountBoxes {

    constructor(payment) {
        this.currency = $('.price-boxes-container').attr('data-currency');
        this.discountCoeficient = $('#amount-boxes-container').attr('data-discountCoeficient');
        this.payment = payment;
    }

    setup(priceBoxEl) {
        this.resetSelection(true);
        this.showBoxes();
        this.setPrices(priceBoxEl);

        $('.amount-box').on('click', (event) => {
            this.onClick($(event.currentTarget), priceBoxEl);
        });
    }

    onClick(amountBoxEl, priceBoxEl) {
        this.resetSelection();

        amountBoxEl.addClass('selected');

        const amountBoxButton = amountBoxEl.find('.select-button');
        $('.select-button-text', amountBoxButton).text(amountBoxButton.attr('data-alternativeText'));
        $('input', amountBoxButton).prop('checked', true);
        amountBoxButton.addClass('selected');
        
        const amount = amountBoxEl.attr('data-amount');
        $('#amount-input').val(amount);
        this.setAmountNumberSpan(amount);

        this.showGiftCertNamesInputs(amount);

        this.payment.showPaymentBlock(priceBoxEl, amountBoxEl.data('price'));
    }


    showBoxes() {
        $('#amount-boxes-container').collapse();
        smoothScrollToTarget('#amount-boxes-container', 1600);
    }

    setAmountNumberSpan(amount) {
        $('.amount-number').text('');
        if(amount > 1) { $('.amount-number').text(amount + 'x'); }
    }

    showGiftCertNamesInputs(amount) {
        $('.name-container').hide();
        for(let i = 0; i < amount; i++) { $('.name-container-' + i).show(); }
    }

    resetSelection(hidePaymentBlock = false) {
        $('.amount-box').removeClass('selected');
    
        $('.amount-box .select-button').each((index, element) => {
            $(element).removeClass('selected');
            $('input', element).prop('checked', false);
            $('.select-button-text', element).text($(element).attr('data-baseText'));
        });

        if(hidePaymentBlock) { $('#paymentBlock').collapse('hide'); }
    }

    setPrices(priceBoxEl) {
        const basePrice = parseInt($(priceBoxEl).attr('data-price'));

        let price = basePrice;
        $('.amount-box').each((index, amountBoxEl) => {
            price = this.calculateBoxPrices(amountBoxEl, basePrice, price)
        })
    }
    calculateBoxPrices(amountBoxEl, basePrice, price) {

        const amount = parseInt($(amountBoxEl).attr('data-amount'));
        const unitPrice = Math.floor(price / amount);

        this.fillBoxWithPrices(amountBoxEl, unitPrice, price);

        return this.getNextPrice(amount, basePrice);
    }
    fillBoxWithPrices(amountBoxEl, unitPrice, price) {
        $(amountBoxEl).find('.unit-price').text(formatCurrency(unitPrice, this.currency))

        $(amountBoxEl).find('.price').text(formatCurrency(price, this.currency));
        $(amountBoxEl).data('price', price);
    }
    getNextPrice(amount, basePrice) {
        const nextAmount = (amount + 1);
        const nextPrice = nextAmount * basePrice;

        const discount = Math.floor(nextPrice * ((nextAmount - 1) * this.discountCoeficient));
        return Math.floor(nextPrice - discount);
    }


   
}
